import { useState } from "react";
import { FiCheckCircle, FiTag } from "react-icons/fi";

import InputField from "../InputField";
import Button from "../Button";

export default function CouponForm({ applyCoupon, coupon_amount }) {
  const [code, setCode] = useState("");

  const handleApply = () => {
    const normalizedCode = code.trim();

    if (!normalizedCode) return;

    applyCoupon(normalizedCode);
  };

  const hasCoupon = Number(coupon_amount) > 0;

  return (
    <div>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-50 text-amber-500">
            <FiTag className="h-5 w-5" />
          </div>

          <div>
            <h3 className="font-bold text-slate-800">کد تخفیف</h3>
            <p className="mt-0.5 text-xs text-slate-500">
              اگر کد تخفیف دارید، آن را وارد کنید.
            </p>
          </div>
        </div>

        {hasCoupon && (
          <div className="flex items-center gap-1.5 self-start rounded-full bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-600 sm:self-auto">
            <FiCheckCircle className="h-4 w-4" />
            کد تخفیف اعمال شده است
          </div>
        )}
      </div>

      <div className="mt-5 flex flex-col gap-3 sm:flex-row">
        <div className="flex-1">
          <InputField
            type="text"
            placeholder="کد تخفیف را وارد کنید"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
        </div>

        <Button
          variant="primary"
          onClick={handleApply}
          className="min-w-28 whitespace-nowrap px-5"
        >
          اعمال کد
        </Button>
      </div>

      {hasCoupon && (
        <p className="mt-3 text-xs text-emerald-600">
          مبلغ{" "}
          <span className="font-bold">
            {Number(coupon_amount).toLocaleString("fa-IR")} تومان
          </span>{" "}
          تخفیف برای این سفارش اعمال شده است.
        </p>
      )}
    </div>
  );
}
